var IMAGE_TYPE = 'wix-draft-plugin-image';
var IMAGE_TYPE_LEGACY = 'IMAGE';
var getDefaultComponentData = function () { return ({
    config: {
        alignment: 'center',
        size: 'content',
        showTitle: true,
        showDescription: true,
    },
}); };
export { IMAGE_TYPE_LEGACY, IMAGE_TYPE, getDefaultComponentData };
//# sourceMappingURL=types.js.map